// Typed accessor over import.meta.env (Vite). API base defaults to "" so requests
// hit the same origin and are proxied in dev (see vite.config.ts).

interface AdminEnv {
  apiBase: string;
  appName: string;
  sessionMode: string;
}

function read(key: string, fallback: string): string {
  const v = (import.meta.env as Record<string, string | undefined>)[key];
  return v == null || v === "" ? fallback : v;
}

// Strip a trailing slash so we can concatenate paths safely.
const rawBase = read("VITE_API_BASE_URL", "");

export const env: AdminEnv = {
  apiBase: rawBase.replace(/\/+$/, ""),
  appName: read("VITE_APP_NAME", "maitv · Admin"),
  sessionMode: read("VITE_SESSION_MODE", "cookie"),
};
